var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.$style.container},[_c('app-photos-swiper',{attrs:{"year":2023,"items":_vm.items}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }